import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/Home')
  },
  {
    path: '/identity',
    name: 'Identity',
    component: () => import('../views/Identity/Identity'),
    children: [
      {
        path: 'logo',
        name: 'LogoPage',
        meta:{
          title: 'Логотип'
        },
        component: () => import('../views/Identity/Pages/LogoPage')
      },
      {
        path: 'color',
        name: 'ColorPage',
        meta:{
          title: 'Цвета'
        },
        component: () => import('../views/Identity/Pages/ColorPage')
      },
      {
        path: 'typography',
        name: 'TypographyPage',
        meta:{
          title: 'Типографика'
        },
        component: () => import('../views/Identity/Pages/TypographyPage')
      },
      {
        path: 'picto',
        name: 'pictoPage',
        meta:{
          title: 'Пиктограммы'
        },
        component: () => import('../views/Identity/Pages/PictoPage')
      },
      {
        path: 'style',
        name: 'StylePage',
        meta:{
          title: 'Фирменный стиль'
        },
        component: () => import('../views/Identity/Pages/StylePage')
      },
      {
        path: 'patterns',
        name: 'PatternsPage',
        meta:{
          title: 'Паттерны'
        },
        component: () => import('../views/Identity/Pages/PatternsPage')
      },
      {
        path: 'photo-style',
        name: 'PhotostylePage',
        meta:{
          title: 'Фотостиль'
        },
        component: () => import('../views/Identity/Pages/PhotostylePage')
      },
      {
        path: 'illustrations',
        name: 'IllustrationsPage',
        meta:{
          title: 'Иллюстрации'
        },
        component: () => import('../views/Identity/Pages/IllustrationsPage')
      },
      {
        path: 'communication-rules',
        name: 'CommunicationRulesPage',
        meta:{
          title: 'Тон коммуникаций', class: 'no-wrap'
        },
        component: () => import('../views/Identity/Pages/CommunicationRulesPage')
      }
    ]
  },
  {
    path: '/brand',
    name: 'Brand',
    component: () => import('../views/Brand/Brand'),
    children: [
      {
        path: 'office-identity',
        name: 'OfficeIdentityPage',
        meta:{
          title: 'Офисная айдентика'
        },
        component: () => import('../views/Brand/Pages/OfficeIdentityPage')
      },
      {
        path: 'presentations',
        name: 'PresentationsPage',
        meta:{
          title: 'Презентации'
        },
        component: () => import('../views/Brand/Pages/PresentationsPage')
      },
      {
        path: 'letters-and-mailings',
        name: 'LettersAndMailingsPage',
        meta: {
          title: 'Письма и рассылки'
        },
        component: () => import('../views/Brand/Pages/LettersAndMailingsPage')
      },
      {
        path: 'souvenir-products',
        name: 'SouvenirProductsPage',
        meta:{
          title: 'Сувенирная продукция'
        },
        component: () => import('../views/Brand/Pages/SouvenirProductsPage')
      },
      {
        path: 'event-decoration',
        name: 'EventDecorationPage',
        meta: {
          title: 'Оформление мероприятий'
        },
        component: () => import('../views/Brand/Pages/EventDecorationPage')
      },
      {
        path: 'clothes',
        name: 'ClothesPage',
        meta: {
          title: 'Одежда'
        },
        component: () => import('../views/Brand/Pages/ClothesPage')
      },
      {
        path: 'transport',
        name: 'TransportPage',
        meta: {
          title: 'Транспорт'
        },
        component: () => import('../views/Brand/Pages/TransportPage')
      },
      {
        path: 'video-and-animation',
        name: 'VideoAndAnimationPage',
        meta: {
          title: 'Видео и анимация'
        },
        component: () => import('../views/Brand/Pages/VideoAndAnimationPage')
      },
      {
        path: 'smm',
        name: 'SmmPage',
        meta: {
          title: 'SMM'
        },
        component: () => import('../views/Brand/Pages/SmmPage')
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  scrollBehavior: () => ({ x: 0, y: 0 }),
  routes
})

export default router
